module.exports = __webpack_public_path__ + "img/11.6821ade7.jpg";